import { strapiInstance } from '@utilities/axios/strapi'
import { strapiResponseInterface } from '@components/CMS/types'
import { blogType } from '@components/CMS/Blogs/types'
import { GetServerSideProps } from 'next'
import Blog from '@components/CMS/Blogs/Blog'
import { serializeMarkdowns } from '@components/CMS/functions'

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  if (!params || !params.slug)
    return {
      notFound: true,
    }

  const { data }: { data: strapiResponseInterface<blogType[]> } =
    await strapiInstance.get(
      `/posts?filters[slug][$eq]=${params.slug}&populate=*`
    )
  const serializedData = await serializeMarkdowns(
    'content',
    data as strapiResponseInterface<blogType[]>
  )

  const {
    data: [blogFound],
    meta,
  } = serializedData

  return { props: { data: blogFound, meta } }
}

export default Blog
